class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.activeVideos = [];

    window.loadSwiper.then((swiper) => {
      this.swiperLib = swiper;
      this._initThumbsCarousel();
      this._initCarousel();
    });
  }

  connectedCallback() {
    this.handleVariantChange = (e) => {
      const { variant } = e.detail;

      if (!variant?.featured_media) return;

      const mediaId = parseInt(variant.featured_media?.id);

      this.querySelectorAll("[data-media-id]").forEach((media) => {
        media.style.display =
          parseInt(media.dataset.mediaId) === mediaId ? null : "none";
      });

      this.gallerySwiper.slideToLoop(0);
    };

    document.addEventListener("variant:changed", this.handleVariantChange);
  }

  disconnectedCallback() {
    document.removeEventListener("variant:changed", this.handleVariantChange);
  }

  _initThumbsCarousel() {
    if (this.thumbsSwiper) return;

    const container = this.querySelector(
      `.${this._prefix}__thumbnails-container`,
    );

    if (!container) return;

    const { Swiper, Thumbs, Mousewheel } = this.swiperLib;

    const swiperParams = {
      modules: [Thumbs, Mousewheel],
      slidesPerView: "auto",
      cssMode: true,
      direction: "vertical",
      watchSlidesProgress: true,
      mousewheel: true,
    };

    this.thumbsSwiper = new Swiper(container, swiperParams);
  }

  _initCarousel() {
    const { Swiper, Pagination } = this.swiperLib;

    if (this.gallerySwiper) return;

    let swiperParams = {
      modules: [Pagination],
      slidesPerView: "auto",
      loop: true,
      speed: 400,
      watchSlidesProgress: true,
      centerInsufficientSlides: true,
    };

    if (this.thumbsSwiper) {
      swiperParams = {
        ...swiperParams,
        thumbs: {
          swiper: this.thumbsSwiper,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        navigation: {
          nextEl: this.querySelector("[data-thumb-navigation-next]"),
          prevEl: this.querySelector("[data-thumb-navigation-previous]"),
        },
      };
    }

    this.gallerySwiper = new Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    this.gallerySwiper.on("slideChange", (e) => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    });
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 959px)").matches;
  }
}

if (!customElements.get("media-gallery")) {
  customElements.define("media-gallery", MediaGallery);
}
